module.exports = __webpack_public_path__ + "img/50.b01df69d.png";